import type { RouteObject } from 'react-router';
import { RequerPermissao } from '@/app/RequerPermissao';
import { paginaSobDemanda } from '@/app/pagina-sob-demanda';

/**
 * Rotas da agenda (iteração 12.3; ADR 0024), sob `agenda.ver`. 🚨 Segunda tranca: a que vale é o `@Permissao()`
 * do backend. Ver a agenda de outra pessoa (`agenda.ver_equipe`) é decidido dentro da página e no servidor.
 */
export const rotas: RouteObject[] = [
  {
    element: <RequerPermissao permissao="agenda.ver" />,
    children: [
      {
        path: '/agenda',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaAgenda'),
          (m) => m.PaginaAgenda,
          'Abrindo a agenda…',
        ),
      },
    ],
  },
];
